import { render } from "./ServiciosProgramadosListadoSolicitudesDetalle.vue?vue&type=template&id=a9be2668&ts=true"
import script from "./ServiciosProgramadosListadoSolicitudesDetalle.vue?vue&type=script&lang=ts"
export * from "./ServiciosProgramadosListadoSolicitudesDetalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__